import React from 'react'
import LogoWhite from './logoWhite.svg'
import LogoBlue from './logo.svg'
import { useTranslation } from 'react-i18next'
import { useColorMode } from '@chakra-ui/react'
import { LIGHT_THEME, DARK_THEME } from '../../lib/constants'

const Logo = ({width, color}) => {
    const { i18n } = useTranslation()
    const { colorMode } = useColorMode()

    switch (color) {
        case 'white':
            return (
                <a href={`/?lang=${i18n.language}`}>
                    <img className="" src={LogoWhite} alt="" width={width} />
                </a>
            )
        case 'blue':
            return (
                <a href={`/?lang=${i18n.language}`}>
                    <img className="" src={LogoBlue} alt="" width={width} />
                </a>
            )
        default:
            return (
                <a href={`/?lang=${i18n.language}`}>
                    {colorMode === LIGHT_THEME && <img className="" src={LogoBlue} alt="" width={width} />}
                    {colorMode === DARK_THEME && <img className="" src={LogoWhite} alt="" width={width} />}
                </a>
            )
    }
}

Logo.defaultProps = {
    width: '200px',
}

export default Logo
